import { useQuery } from 'react-query';
import { client } from 'utils/api-client';

export default function usePageBanner(path) {
  return useQuery(['page-link', path], (_, urlPath) =>
    client(`banner/${urlPath}`).then((res) => res)
  );
}
